import { Signal1 } from "@/js/util/event/Signal1";

export default class Stage {
  public readonly onResize: Signal1<Stage>;

  constructor(width: number, height: number) {
    this._width = width;
    this._height = height;
    this.onResize = new Signal1<Stage>();
  }

  setDimensions(width: number, height: number): void {
    this._width = width;
    this._height = height;
    this.onResize.emit(this);
  }

  get width(): number {
    return this._width;
  }

  get height(): number {
    return this._height;
  }

  private _width: number;
  private _height: number;
}
